// extracted by mini-css-extract-plugin
export default {"promoSection":"BlackHistorySection_promoSection__iV9eE","container":"BlackHistorySection_container__iaCUL","bannerWrapper":"BlackHistorySection_bannerWrapper__1sgnd"};